import { ChangeDetectionStrategy, Component, forwardRef, input } from '@angular/core';
import { AbstractFormControl } from '@shared/form-controls/abstract-form-control';
import { BuildingApplicationItemDto } from '@artemis-software/wr-api';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'wr-application-status-select',
  templateUrl: './application-status-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ApplicationStatusSelectComponent),
      multi: true,
    },
  ],
})
export class ApplicationStatusSelectComponent extends AbstractFormControl<BuildingApplicationItemDto.StatusEnum> {
  readonly Status = BuildingApplicationItemDto.StatusEnum;

  showEmptyOption = input<boolean>(true);


}
